<div class="table-scroll-wrapper">
    <table class="table-primary">
        <thead>
        <tr>
          <ng-container *ngFor="let column of columns; trackBy: trackByColFn">
            <th *ngIf="column.sortable; else notSortable"
              class="sort"
              [class.text-left]="column?.fieldType !== FieldType.Number"
              [class.text-right]="column?.fieldType === FieldType.Number"
              (click)="sortByColumn(column)"
              [ngStyle]="column.style"
            > {{column.header}}
            <img [class.asc]="tableColumns[column.field]" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
            </th>

            <ng-template #notSortable>
              <th
                class="sort"
                [class.text-left]="column?.fieldType !== FieldType.Number"
                [class.text-right]="column?.fieldType === FieldType.Number"
                [ngStyle]="column.style">
                {{column.header}}
              </th>
            </ng-template>
          </ng-container>
          <th class="controls" *ngIf="withDetailsOption"></th>
        </thead>
        <tbody *ngIf="data?.length" [appOverflowClass]>
        <tr class="table-row" *ngFor="let item of data; let i = index; trackBy: trackByFn"
        (click)="onRowClick.next(i)"
        >
          <td *ngFor="let column of columns"
            [class.text-left]="column?.fieldType !== FieldType.Number"
            [class.text-right]="column?.fieldType === FieldType.Number"
            [ngStyle]="column.style"
            [ngClass]="column.class"
            [ngSwitch]="column.RowType"
          >

              <div *ngSwitchCase="RowType.Double">
                <div [ngSwitch]="column.doubleRowField?.headingFieldType">
                  <div class="heading" *ngSwitchCase="FieldType.DateTime">
                    {{(item[column.doubleRowField?.headingField] || getNestedProperty(item, column.doubleRowField?.headingField)) | formattedDate: 'MMM d a, HH:mm yyyy'}}
                  </div>
                  <div class="heading" *ngSwitchDefault>
                    {{ item[column.doubleRowField?.headingField] || 
                    getNestedProperty(item, column.doubleRowField?.headingField)
                    }}
                     <ng-container *ngIf="column.doubleRowField.headingField2 && column.doubleRowField?.headingField2Type === FieldType.LastName">
                      {{item[column.doubleRowField?.headingField2]?.[0] || getNestedProperty(item, column.doubleRowField?.headingField2)?.[0]}}. 
                    </ng-container>
                  </div>
                </div>
                <div class="secondary" [ngSwitch]="column.doubleRowField?.secondaryFieldType1">
                  <div *ngSwitchCase="FieldType.DateTime">
                    {{(item[column.doubleRowField?.secondaryField1] || getNestedProperty(item, column.doubleRowField?.secondaryField1)) | formattedDate: 'MMM d a, HH:mm yyyy' }} 
                  </div>
                  <div *ngSwitchDefault>
                    {{item[column.doubleRowField?.secondaryField1] || getNestedProperty(item, column.doubleRowField?.secondaryField1)}} 
                    <ng-container *ngIf="column.doubleRowField.secondaryField2 && column.doubleRowField?.secondaryFieldType2 === FieldType.LastName">
                      {{item[column.doubleRowField?.secondaryField2]?.[0] || getNestedProperty(item, column.doubleRowField?.secondaryField2)?.[0]}}. 
                    </ng-container>
                  </div>
                </div>
              </div>

              <div *ngSwitchCase="RowType.Name">
                <span>{{item[column.nameRow?.firstNameField] || getNestedProperty(item, column.nameRow?.firstNameField)}}</span> <span> 
                  {{item[column.nameRow?.lastNameField]?.[0] || getNestedProperty(item, column.nameRow?.lastNameField)?.[0]}}.</span>
              </div>

              <!-- pass in unshared item -->
              <div *ngSwitchCase="RowType.Template">
                <ng-container *ngIf="template">
                  <ng-container *ngTemplateOutlet="template; context: {$implicit: item, index: i}"></ng-container>
                </ng-container>
              </div>

              <div *ngSwitchDefault [ngSwitch]="column.fieldType"> 
                <container-element *ngSwitchCase="FieldType.DateTime">
                  {{ item[column.field] | formattedDate: 'MMM d a, HH:mm yyyy'}}
                </container-element>
                <container-element *ngSwitchCase="FieldType.Date">
                  {{ item[column.field] | date}}
                </container-element>
                <container-element *ngSwitchCase="FieldType.ActivityBadge">
                  <app-badge [color]="(item | transactionBadge)?.color">
                    {{(item | transactionBadge)?.label}}
                  </app-badge>
                </container-element>
                <container-element *ngSwitchDefault>
                  {{ item[column.field] || getNestedProperty(item, column.field) }}
                </container-element>
              </div>

              <div *ngSwitchCase="RowType.RemoveRowButton"
                  class="remove-btn"
                >
                  <img class="delete" src="assets/icons/icon-basket.svg" alt="delete" 
                  (click)="deleteRow(i, item)"/>
                </div>
            </td>
          <td class="text-right controls" *ngIf="withDetailsOption">
            <button (click)="$event.stopPropagation(); goToDetail.next(item?.id)"
                    [disabled]="loading"
                    class="details-btn animation-focus-default"
            >
              {{detailsControlName}}
            </button>
          </td>
        </tr>
        </tbody>
      </table>
  </div>